import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Sidebar from './components/commonView/Sidebar';
import TopNavbar from './components/commonView/TopNavbar';
import Administrator from './pages/Administrator/Administrator.jsx';
import Dashboard from './pages/Dashboard/Dashboard.jsx';
import Beacons from './pages/Beacons/Beacons.jsx';
import Building from './pages/Building/Building.jsx';
import Merchants from './pages/Merchants/Merchants.jsx';
import Shops from './pages/Shops/Shops.jsx';
import ServiceProviders from './pages/ServiceProviders/ServiceProviders.jsx';
import SystemUsers from './pages/SystemUsers/SystemUsers.jsx';
import Login from './pages/Login/Login.jsx';
import BeaconMapper from './pages/BeaconMapper/index.jsx';

const App = () => { 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/*"
            element={
              <>
                <TopNavbar isSidebarOpen={isSidebarOpen} />
                <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/administrator" element={<Administrator />} />
                    <Route path="/beacons" element={<Beacons />} />
                    <Route path="/building" element={<Building />} />
                    <Route path="/merchants" element={<Merchants />} />
                    <Route path="/shops" element={<Shops />} />
                    <Route path="/serviceProviders" element={<ServiceProviders />} />
                    <Route path="/systemUsers" element={<SystemUsers />} />
                    <Route path="/beaconMapper" element={<BeaconMapper />} />
                  </Routes>
                </Sidebar>
              </>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
